module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/earrings/drop-506cad3acb5213ef0b123096c7d78384.webp";